export default __webpack_public_path__ + "static/WellBiz-0d181ec2f9c8bf1c7e85de9fd1033dbc.png";